import { ApplicationConstants } from '../../../../shared/applicationConstants';
import { SharedService } from '../../../../shared/services/sharedService';
import { AuthService } from '../../../../login/services/authService.js';

export class BajaUsuariService {

    static deleteUser(){
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.deleteUserByUid, { uid: uid, token: token, type : 'deleteAll' }).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    return response.body;
                }
                else {
                   return response.body;
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/perfil/components/baja-modal/services/bajaUsuariService.js